export default __webpack_public_path__ + "static/media/GetHelp_Payroll.17c38011.svg";